import {NFLookupCatalog} from "./NFLookupCatalog";
import {AppEntities} from "../../../config/entities";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import React from "react";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    companyId?: string;
    warehouseId?: string;
    width?: number;
    selectedCatalog?: boolean;
    setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupDivision = ({
                                     title,
                                     fieldName,
                                     required,
                                     showBorder,
                                     companyId,
                                     warehouseId,
                                     width,
                                     selectedCatalog,
                                     setSelectedCatalog,
                                 }: IProps) => {
    const loadData = async (searchText: string | undefined) => {
        return await AppEntities.Division.getDataService().GetAllFilteredByCompanyAndDivision(
            searchText,
            companyId,
            warehouseId
        );
    };

    return (
        <>
            <NFLookupCatalog
                fieldName={fieldName}
                title={title}
                entity={AppEntities.Division}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                width={width}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
            >
                <NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>
                <NFLookupCatalogColumn fieldName={"name"} caption={"Name"}/>
            </NFLookupCatalog>
        </>
    );
};
